import { matchPath } from 'react-router';
import { buildSortFilterSearchQuery, parseSortFiltersSearchQuery, SortFiltersParams } from './sortFiltersParams';
import { createRoute } from './createRoute';
import { generatePath } from './generatePath';

export interface CategoryPageParams extends SortFiltersParams {
  page: number;
  categorySlug: string;
}

export interface CategoryPage {
  routeName: 'category';
  params: CategoryPageParams;
}

export const categoryRoute = createRoute<CategoryPageParams, 'categorySlug'>({
  pattern: '/html/:categorySlug/:page?',
  build: (pattern, params) => {
    const { page, categorySlug } = params;

    const pathParams = {
      page: page == null || page === 1 ? null : String(page),
      categorySlug: (categorySlug || '').toLowerCase(),
    };

    const searchQuery = buildSortFilterSearchQuery(params);
    return {
      pathname: generatePath(pattern, pathParams),
      search: searchQuery,
    };
  },
  match: (pattern, location) => {
    const { pathname, search } = location;
    const match = matchPath({ path: pattern }, pathname);

    if (!match) {
      return null;
    }

    // The optional `:page?` segment is unconstrained in React Router v6 (the v5
    // `(\\d+)` numeric constraint is unsupported), so reject a non-numeric page
    // here to keep `/html/:categorySlug/:subCategorySlug` matching subCategoryRoute.
    const { page } = match.params;
    if (page !== undefined && !/^\d+$/.test(page)) {
      return null;
    }

    const requestedPage = Number(page);
    return {
      ...parseSortFiltersSearchQuery(search),
      categorySlug: decodeURIComponent(match.params.categorySlug ?? ''),
      page: requestedPage || 1,
    };
  },
});
